import { Link as RouterLink } from "react-router-dom";
import { Box, Link } from "@mui/material";
import logoImage from "svg_icons/logo-white.svg";

export const LogoLink: React.FC = () => {
  return (
    <Box pt={0.75} pl={2}>
      <Link component={RouterLink} to="/" data-testid="home-button">
        <img alt="app-logo" src={logoImage} height={34} width={124} />
      </Link>
    </Box>
  );
};
